
import { Inertia } from '@inertiajs/inertia'

/////////////////////////////
// Android Exposed Methods //
/////////////////////////////

window.pauseApp = () => {
  if (! $vm || $vm.$page.component !== 'Dashboard') {
    return
  }
  if ($vm.$store.state.workingModes.event) {
    return // REV-21355
  }
  $vm.$store.dispatch('$log', 'Pause - app going to background mode')
  $vm.$store.dispatch('lockScreen')
}

window.resumeApp = () => {
  if (! $vm || $vm.$page.component !== 'Dashboard') {
    return
  }
  if ($vm.$store.state.workingModes.event) {
    return // REV-21355
  }
  $vm.$store.dispatch('$log', 'Resume - app coming from background mode')
  if ($vm.$page.props.auth.demo) {
    const firstTenantUser = $vm.$store.state.rummage.data.TenantUser?.find(o => !! o.active)
    $vm.$store.dispatch('unlockScreen', firstTenantUser)
  }
}

window.deleteAppData = () => {
  localStorage.clear()
  if ($vm?.$page.props.auth.tenant) {
    Inertia.delete('')
  }
}
